module.exports = __webpack_public_path__ + "static/media/csgo.a2c45af7.png";